import {defineMessages, FormattedMessage, injectIntl} from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

import Box from '../box/box.jsx';
import Modal from '../../containers/modal.jsx';

import styles from './block-export-modal.css';

const messages = defineMessages({
    title: {
        defaultMessage: 'Export Block Image',
        description: 'Title for the block image export modal',
        id: 'gui.blockExportModal.title'
    },
    description: {
        defaultMessage: 'Select an image format. PNG is the default.',
        description: 'Description for the block image export modal',
        id: 'gui.blockExportModal.description'
    },
    formatLabel: {
        defaultMessage: 'Format',
        description: 'Label for export format select in the block image export modal',
        id: 'gui.blockExportModal.formatLabel'
    },
    cancel: {
        defaultMessage: 'Cancel',
        description: 'Button text to cancel block image export',
        id: 'gui.blockExportModal.cancel'
    },
    export: {
        defaultMessage: 'Export',
        description: 'Button text to confirm block image export',
        id: 'gui.blockExportModal.export'
    }
});

const BlockExportModal = props => (
    <Modal
        className={styles.modalContent}
        contentLabel={props.intl.formatMessage(messages.title)}
        id="blockExportModal"
        onRequestClose={props.onCancel}
    >
        <Box className={styles.body}>
            <h2 className={styles.title}>
                <FormattedMessage {...messages.title} />
            </h2>
            <p className={styles.description}>
                <FormattedMessage {...messages.description} />
            </p>
            <div className={styles.field}>
                <label
                    className={styles.label}
                    htmlFor="block-export-format"
                >
                    <FormattedMessage {...messages.formatLabel} />
                </label>
                <select
                    autoFocus
                    className={styles.select}
                    id="block-export-format"
                    value={props.format}
                    onChange={props.onChangeFormat}
                >
                    <option value="png">{'PNG'}</option>
                    <option value="svg">{'SVG'}</option>
                </select>
            </div>
            <Box className={styles.buttonRow}>
                <button
                    className={`${styles.button} ${styles.cancelButton}`}
                    onClick={props.onCancel}
                >
                    <FormattedMessage {...messages.cancel} />
                </button>
                <button
                    className={`${styles.button} ${styles.exportButton}`}
                    onClick={props.onExport}
                >
                    <FormattedMessage {...messages.export} />
                </button>
            </Box>
        </Box>
    </Modal>
);

BlockExportModal.propTypes = {
    format: PropTypes.oneOf(['png', 'svg']).isRequired,
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }).isRequired,
    onCancel: PropTypes.func.isRequired,
    onChangeFormat: PropTypes.func.isRequired,
    onExport: PropTypes.func.isRequired
};

export default injectIntl(BlockExportModal);
